/**
 * 접수목록 [푸시/불러톡] 모달 — $j.F.Admin.OrderPushSend (정적 모듈)
 *
 * 마크업은 adm/pages/order/pushSend.blade.php (/adm/ajax/order/push-send 가 그린다). OrderList.js 가 JBModal 로 띄운 뒤
 * init() 을 부른다. 고른 오더들에 현장도착·작업종료·수금완료·환원 예정 푸시를 차례로 보내거나,
 * 발주자·수주자에게 불러톡을 보낸다. 대상 목록·보내는 관리자는 모달 안 JSON 블록(.ops-data).
 */
var _startNum = 0;
var _stMode = 0;
var _sendList = [];
var _sooList = [];
var _balList = [];
var _senderNum = 0;
var _senderName = '';

function _samAsDefault(){
    var str = "[장비불러!] 삼성 에어컨AS 오더<br><br>";
    str += "★삼성 작업확인서 (시간 체크)<br>";
    str += "☆작업사진 3컷이상 어플에 업로드 필수<br><br>";
    str += "※ 결제책임 : 스카이연합 익월 말 결제<br>";
    str += "(사업자등록증 익월 중순에 송부)<br><br>";
    var obj = document.getElementById("jbtalkinputvals");
    obj.innerHTML = obj.innerHTML + str;
}

function _sendTalkStart(toWho){
    var list = (toWho == 1) ? _balList : _sooList;
    for(var i = 0; i < list.length; i++){
        _sendTalk(list[i], i + 1, list.length);
    }
}

function _sendTalk(mb_no, seq, total){
    if(mb_no < 1) return;
    var mcont = document.getElementById("jbtalkinputvals").innerText;
    $.ajax({
        type: "POST", url: "/ajax/chat/send",
        data: {
            jobAct: "personalmessagesending", roomno: mb_no, sendernum: _senderNum,
            talkName: _senderName, mcont: mcont, eafile: "", attachfile1: "", attachfile2: "", CurrentmembersList: ""
        },
        success: function(){
            $('#sendStauts').html("Sending Talk : " + seq + " / " + total);
        }
    });
}

function _pushDo(n){
    _stMode = n;
    _startNum = 0;
    _pushNext();
}

function _pushNext(){
    if(_startNum > _sendList.length - 1) return;
    var ea = _sendList[_startNum];
    var obj = document.getElementById("togoxnum");
    if(obj) obj.innerHTML = (_startNum + 1) + "명 / ";

    var types = {1:'request_field_arrival', 2:'request_job_done', 3:'payment_done_request', 4:'cashBackNoticerun'};
    var notitype = types[_stMode];
    if(!notitype) return;

    _startNum++;
    $.ajax({
        type: 'POST', url: '/adm/ajax/order/push-request',
        data: {ordernum: ea[0], notitype: notitype}, dataType: 'json',
        success: function(){ _pushNext(); }
    });
}

export default class OrderPushSend {
    static init() {
        const el = document.querySelector('#jb-modal-push-send .ops-data') || document.querySelector('.ops-data');
        const d = el ? JSON.parse(el.textContent) : {};
        _sendList = d.sendList || []; _sooList = d.sooList || []; _balList = d.balList || [];
        _senderNum = d.senderNum || 0; _senderName = d.senderName || '';
        _startNum = 0; _stMode = 0;

        $('.push-send-form').off('click.ops').on('click.ops', '[data-ops]', function () {
            const a = this.dataset.ops, n = Number(this.dataset.n);
            if (a === 'push') _pushDo(n);
            else if (a === 'talk') _sendTalkStart(n);
            else if (a === 'samAs') _samAsDefault();
        });
    }
}
